"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./Well.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Well = function Well(_ref) {
  var plain = _ref.plain,
      pre = _ref.pre,
      className = _ref.className,
      children = _ref.children;
  var wrapperClass = 'well';
  if (plain) wrapperClass += ' well--plain';
  if (pre) wrapperClass += ' well--pre';
  if (className) wrapperClass += " ".concat(className);
  return _react.default.createElement("div", {
    className: wrapperClass
  }, children);
};

Well.propTypes = {
  /** Define se terá bordas */
  plain: _propTypes.default.bool,

  /** Define o modo de exibição do texto */
  pre: _propTypes.default.bool,

  /** Classes adicionais para o wrapper */
  className: _propTypes.default.string,

  /** HTML ou texto que será renderizado dentro do Well */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired
};
var _default = Well;
exports.default = _default;